var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExcelIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 6,
    fill: "#00AC54"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_3565)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.63 12.2706H14.7216V11.3164H16.63V12.2706ZM16.63 12.8158H14.7216V13.7701H16.63V12.8158ZM16.63 8.31738H14.7216V9.2716H16.63V8.31741V8.31738ZM16.63 9.81687H14.7216V10.7711H16.63V9.81687ZM16.63 14.3153H14.7216V15.2696H16.63V14.3153V14.3153ZM17.9482 16.1965C17.8937 16.4801 17.5529 16.4869 17.3252 16.4964H13.0858V17.7233H12.2392L6 16.6327V7.09191L12.276 6H13.0858V7.08645H17.1794C17.4097 7.09599 17.6633 7.07963 17.8637 7.2173C18.0041 7.41905 17.9905 7.67534 18 7.90706L17.9945 15.0037C17.9877 15.4004 18.0313 15.8053 17.9482 16.1965ZM10.9987 14.0577C10.6225 13.2943 10.2395 12.5364 9.86459 11.773C10.2354 11.0301 10.6007 10.2844 10.9647 9.53878C10.6552 9.55378 10.3458 9.57286 10.0377 9.59468C9.80733 10.1549 9.53878 10.7002 9.35885 11.2796C9.19118 10.7329 8.96899 10.2067 8.76588 9.67374C8.46598 9.6901 8.16607 9.70781 7.86619 9.72553C8.18243 10.4235 8.51916 11.1119 8.82586 11.8139C8.46462 12.4955 8.12655 13.1866 7.77621 13.8723C8.07473 13.8846 8.37328 13.8968 8.6718 13.9009C8.88448 13.3584 9.14892 12.8363 9.33431 12.2828C9.50063 12.8772 9.78279 13.4266 10.0145 13.995C10.3431 14.0182 10.6702 14.0386 10.9987 14.0577H10.9987ZM17.3498 7.73386H13.0858V8.31738H14.1763V9.2716H13.0858V9.81687H14.1763V10.7711H13.0858V11.3164H14.1763V12.2706H13.0858V12.8158H14.1763V13.7701H13.0858V14.3153H14.1763V15.2696H13.0858V15.9H17.3498V7.73386Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_3565"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcelIcon);
export default __webpack_public_path__ + "static/media/excelIcon.6f601b455c8f5ba77fa972c5ef350bb9.svg";
export { ForwardRef as ReactComponent };